/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const onCreateEc2Config = /* GraphQL */ `
  subscription OnCreateEc2Config(
    $filter: ModelSubscriptionEc2ConfigFilterInput
    $owner: String
  ) {
    onCreateEc2Config(filter: $filter, owner: $owner) {
      id
      skipCfn
      simulateCreationError
      terminateTimestamp
      userId
      lab
      finished
      labStatus
      createdAt
      updatedAt
      owner
    }
  }
`;
export const onUpdateEc2Config = /* GraphQL */ `
  subscription OnUpdateEc2Config(
    $filter: ModelSubscriptionEc2ConfigFilterInput
    $owner: String
  ) {
    onUpdateEc2Config(filter: $filter, owner: $owner) {
      id
      skipCfn
      simulateCreationError
      terminateTimestamp
      userId
      lab
      finished
      labStatus
      createdAt
      updatedAt
      owner
    }
  }
`;
export const onDeleteEc2Config = /* GraphQL */ `
  subscription OnDeleteEc2Config(
    $filter: ModelSubscriptionEc2ConfigFilterInput
    $owner: String
  ) {
    onDeleteEc2Config(filter: $filter, owner: $owner) {
      id
      skipCfn
      simulateCreationError
      terminateTimestamp
      userId
      lab
      finished
      labStatus
      createdAt
      updatedAt
      owner
    }
  }
`;
export const onCreateLabDetail = /* GraphQL */ `
  subscription OnCreateLabDetail(
    $filter: ModelSubscriptionLabDetailFilterInput
    $owner: String
  ) {
    onCreateLabDetail(filter: $filter, owner: $owner) {
      id
      lab
      lastCreationTimeInSeconds
      lastDurationInSeconds
      lastTimeStarted
      lastTimeEnded
      history {
        items {
          id
          userId
          creationTimeInSeconds
          durationInSeconds
          timeStarted
          timeEnded
          ttl
          createdAt
          updatedAt
          labDetailHistoryId
          owner
        }
        nextToken
      }
      createdAt
      updatedAt
      owner
    }
  }
`;
export const onUpdateLabDetail = /* GraphQL */ `
  subscription OnUpdateLabDetail(
    $filter: ModelSubscriptionLabDetailFilterInput
    $owner: String
  ) {
    onUpdateLabDetail(filter: $filter, owner: $owner) {
      id
      lab
      lastCreationTimeInSeconds
      lastDurationInSeconds
      lastTimeStarted
      lastTimeEnded
      history {
        items {
          id
          userId
          creationTimeInSeconds
          durationInSeconds
          timeStarted
          timeEnded
          ttl
          createdAt
          updatedAt
          labDetailHistoryId
          owner
        }
        nextToken
      }
      createdAt
      updatedAt
      owner
    }
  }
`;
export const onDeleteLabDetail = /* GraphQL */ `
  subscription OnDeleteLabDetail(
    $filter: ModelSubscriptionLabDetailFilterInput
    $owner: String
  ) {
    onDeleteLabDetail(filter: $filter, owner: $owner) {
      id
      lab
      lastCreationTimeInSeconds
      lastDurationInSeconds
      lastTimeStarted
      lastTimeEnded
      history {
        items {
          id
          userId
          creationTimeInSeconds
          durationInSeconds
          timeStarted
          timeEnded
          ttl
          createdAt
          updatedAt
          labDetailHistoryId
          owner
        }
        nextToken
      }
      createdAt
      updatedAt
      owner
    }
  }
`;
export const onCreateLabDetailHistory = /* GraphQL */ `
  subscription OnCreateLabDetailHistory(
    $filter: ModelSubscriptionLabDetailHistoryFilterInput
    $owner: String
  ) {
    onCreateLabDetailHistory(filter: $filter, owner: $owner) {
      id
      userId
      creationTimeInSeconds
      durationInSeconds
      timeStarted
      timeEnded
      ttl
      createdAt
      updatedAt
      labDetailHistoryId
      owner
    }
  }
`;
export const onUpdateLabDetailHistory = /* GraphQL */ `
  subscription OnUpdateLabDetailHistory(
    $filter: ModelSubscriptionLabDetailHistoryFilterInput
    $owner: String
  ) {
    onUpdateLabDetailHistory(filter: $filter, owner: $owner) {
      id
      userId
      creationTimeInSeconds
      durationInSeconds
      timeStarted
      timeEnded
      ttl
      createdAt
      updatedAt
      labDetailHistoryId
      owner
    }
  }
`;
export const onDeleteLabDetailHistory = /* GraphQL */ `
  subscription OnDeleteLabDetailHistory(
    $filter: ModelSubscriptionLabDetailHistoryFilterInput
    $owner: String
  ) {
    onDeleteLabDetailHistory(filter: $filter, owner: $owner) {
      id
      userId
      creationTimeInSeconds
      durationInSeconds
      timeStarted
      timeEnded
      ttl
      createdAt
      updatedAt
      labDetailHistoryId
      owner
    }
  }
`;
export const onCreateUser = /* GraphQL */ `
  subscription OnCreateUser(
    $filter: ModelSubscriptionUserFilterInput
    $owner: String
  ) {
    onCreateUser(filter: $filter, owner: $owner) {
      id
      kontingentCurrent
      kontingentStartDate
      userId
      createdAt
      updatedAt
      owner
    }
  }
`;
export const onUpdateUser = /* GraphQL */ `
  subscription OnUpdateUser(
    $filter: ModelSubscriptionUserFilterInput
    $owner: String
  ) {
    onUpdateUser(filter: $filter, owner: $owner) {
      id
      kontingentCurrent
      kontingentStartDate
      userId
      createdAt
      updatedAt
      owner
    }
  }
`;
export const onDeleteUser = /* GraphQL */ `
  subscription OnDeleteUser(
    $filter: ModelSubscriptionUserFilterInput
    $owner: String
  ) {
    onDeleteUser(filter: $filter, owner: $owner) {
      id
      kontingentCurrent
      kontingentStartDate
      userId
      createdAt
      updatedAt
      owner
    }
  }
`;
export const onCreatePost = /* GraphQL */ `
  subscription OnCreatePost(
    $filter: ModelSubscriptionPostFilterInput
    $owner: String
  ) {
    onCreatePost(filter: $filter, owner: $owner) {
      id
      title
      content
      username
      createdAt
      updatedAt
      owner
    }
  }
`;
export const onUpdatePost = /* GraphQL */ `
  subscription OnUpdatePost(
    $filter: ModelSubscriptionPostFilterInput
    $owner: String
  ) {
    onUpdatePost(filter: $filter, owner: $owner) {
      id
      title
      content
      username
      createdAt
      updatedAt
      owner
    }
  }
`;
export const onDeletePost = /* GraphQL */ `
  subscription OnDeletePost(
    $filter: ModelSubscriptionPostFilterInput
    $owner: String
  ) {
    onDeletePost(filter: $filter, owner: $owner) {
      id
      title
      content
      username
      createdAt
      updatedAt
      owner
    }
  }
`;
export const onCreateMessage = /* GraphQL */ `
  subscription OnCreateMessage(
    $filter: ModelSubscriptionMessageFilterInput
    $owner: String
  ) {
    onCreateMessage(filter: $filter, owner: $owner) {
      id
      authorId
      content
      createdAt
      updatedAt
      owner
    }
  }
`;
export const onUpdateMessage = /* GraphQL */ `
  subscription OnUpdateMessage(
    $filter: ModelSubscriptionMessageFilterInput
    $owner: String
  ) {
    onUpdateMessage(filter: $filter, owner: $owner) {
      id
      authorId
      content
      createdAt
      updatedAt
      owner
    }
  }
`;
export const onDeleteMessage = /* GraphQL */ `
  subscription OnDeleteMessage(
    $filter: ModelSubscriptionMessageFilterInput
    $owner: String
  ) {
    onDeleteMessage(filter: $filter, owner: $owner) {
      id
      authorId
      content
      createdAt
      updatedAt
      owner
    }
  }
`;
